// extracted by mini-css-extract-plugin
export var checkbox = "_6o-0";
export var circle = "_6o-3";
export var horizontalContainer = "_6o-7";
export var sm = "_6o-5";
export var switch0 = "_6o-2";
export var switchDisabled = "_6o-8";
export var switchEnabled = "_6o-1";
export var textSwitchContainer = "_6o-9";
export var textSwitchOption = "_6o-a";
export var textSwitchOptionSelected = "_6o-b";
export var verticalContainer = "_6o-6";
export var xs = "_6o-4";